module.exports = __webpack_public_path__ + "media/images/red-bubble-d456eb24346f671152f0adf7870502e0.png";